// extracted by mini-css-extract-plugin
export default {"action":"PickupRequestFlagButton_action__cOJZk","flagged":"PickupRequestFlagButton_flagged__m0RD5"};